import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ActivityFormService } from 'src/app/trip-calculator/services/activity-form.service';
import { CategorySelectorComponent } from '../../../custom-input/category-selector/category-selector.component';
import { CalculationMode } from 'src/app/trip-calculator/models/calculation-mode.enum';

@Component({
  selector: 'app-select-calculation-mode',
  imports: [
    ReactiveFormsModule,
    RadioButtonModule,
    FormsModule,
    CategorySelectorComponent,
    TranslocoPipe,
  ],
  templateUrl: './select-calculation-mode.component.html',
})
export class SelectCalculationModeComponent implements OnInit, OnDestroy {
  activityFormService = inject(ActivityFormService);
  translocoService = inject(TranslocoService);
  categoryList: {
    icon: string;
    value: string;
    label: string;
    description: string;
  }[] = [];

  ngOnInit() {
    this.initializeCategoryList();
  }
  ngOnDestroy() {
    this.activityFormService.calculationMode.set(null);
  }
  get calculationMode() {
    return this.activityFormService.calculationMode();
  }
  set calculationMode(value) {
    this.activityFormService.calculationMode.set(value);
  }

  initializeCategoryList() {
    this.categoryList.push(
      {
        icon: 'ruler-dimension-line',
        value: CalculationMode.Distance,
        label: this.translocoService.translate(
          'calculator.calculationMode.distance.title',
        ),

        description: this.translocoService.translate(
          'calculator.calculationMode.distance.description',
        ),
      },
      {
        icon: 'timer',
        value: CalculationMode.Duration,
        label: this.translocoService.translate(
          'calculator.calculationMode.duration.title',
        ),
        description: this.translocoService.translate(
          'calculator.calculationMode.duration.description',
        ),
      },
    );
  }
}
